module.exports = __webpack_public_path__ + "static/media/timbreallaLogo.6959c22d.png";